function SkeletonTable({ row }: any) {
  return (
    <>
      <div className="animate-pulse flex space-x-4">
        <div className="flex-1 space-y-6 py-1">
          <div className="space-y-12">
            {row &&
              [...Array(row)].map((e, index: number) => (
                <div className={`grid grid-cols-3 gap-4`} key={index}>
                  <div className="h-2 bg-slate-200 rounded col-span-1"></div>
                  <div className="h-2 bg-slate-200 rounded col-span-1"></div>
                  <div className="h-2 bg-slate-200 rounded col-span-1"></div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default SkeletonTable;
